import styled from 'styled-components';

import {
  Menu,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { colors } from '@playbookux/playbook-web-core';

const { SIDEBAR_SELECTED_COLOR, SHOW_SELECTED, LABEL_COLOR } = colors;

const Item = styled(Menu.Item)`
  display: flex;
  height: 35px;
  margin-bottom: 8px;
  color: ${LABEL_COLOR};
`;

const ItemSelected = styled(Item)`
  background-color: ${SIDEBAR_SELECTED_COLOR};
`;

const ItemIcon = styled(SemanticIcon)`
  flex: 1;
  padding: 8px 0 8px 0;
  color: ${LABEL_COLOR};
`;

const ItemLabel = styled.p`
  flex: 2;
  color: ${LABEL_COLOR};
  font-size: 14px;
  padding: 8px 0 8px 0;
  font-weight: 500;
  flex-direction: row;
`;

const ItemShow = styled.div`
  justify-content: flex-end;
  height: 100%;
  width: 6px;
  background-color: ${SHOW_SELECTED} !important;
`;

export {
  Item,
  ItemSelected,
  ItemIcon,
  ItemLabel,
  ItemShow,
};
